<template>
  <div class="py-4 container-fluid">
    <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'export-excel/barang-masuk?material_code='+search.material_code+'&material_name='+search.material_name+'&type='+search.type+'&note='+search.note+'&date='+search.date+'&po_no='+search.po_no+''" target="_BLANK"><i class="fa fa-download fa-sm"></i> Export</a>
    <a class="btn btn-sm btn-info" style="margin-right: 10px;" :href="apiUrl+'print-pdf/stock-in-hse?material_code='+search.material_code+'&material_name='+search.material_name+'&type='+search.type+'&note='+search.note+'&date='+search.date+'&po_no='+search.po_no+''" target="_BLANK"><i class="fa fa-file-pdf-o fa-sm"></i> Print PDF</a>
    <!-- <argon-button color="info" size="sm" class="mb-3" variant="gradient" style="margin-right: 10px;"><i class="fa fa-download fa-sm"></i> Export</argon-button> -->
    <!-- <argon-button color="warning" size="sm" class="mb-3" variant="gradient" @click="modalImport()"><i class="fa fa-upload fa-sm"></i> Import</argon-button> -->
    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-lg-4">
                <div class="card-header pb-0">
                  <h6>Stock In</h6>
                </div>
              </div>
              <div class="col-lg-5">
                <input type="text" class="form-control mt-3" placeholder="Search by Item Name" v-model="search.material_name" @keyup="get()">
              </div>
              <div class="col-lg-3 float-right">
                <argon-button
                  style="margin-right: 10px; margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click="create()"
                ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Item Code</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Item Name</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Specification</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Size</th>
                      <!-- <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Type</th> -->
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Qty</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Note</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Date</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">PO NO.</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Selisih</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">QC</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Created By</th>
                      <th class="text-secondary"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i" @click="setBg(i)" :style="(backgroundRed == i) ? 'background-color: #7FFF00; cursor: pointer;' : 'cursor: pointer;' ">
                      <td class="align-middle text-center text-sm">
                        <router-link :to="/detail-barang/+row.material_code">
                          <span class="badge badge-sm bg-gradient-primary">{{ row.material_code }}</span>
                        </router-link>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.material_name }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.specification }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.size }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.qty}}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.note}}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ moment(row.date).locale('id').format('LL') }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.po_no }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="badge badge-sm bg-gradient-danger" v-if="row.is_discrepancy">Selisih</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="badge badge-sm bg-gradient-success" v-if="row.qc_status == 'Pass'">Pass</span>
                        <span class="badge badge-sm bg-gradient-danger" v-else-if="row.qc_status == 'Reject'">Reject</span>
                        <span class="badge badge-sm bg-gradient-warning" v-else-if="row.qc_status == 'Partial'">Partial</span>
                        <span class="badge badge-sm bg-gradient-secondary" v-else-if="row.qc_status == 'Pending'">Pending</span>
                        <span class="badge badge-sm bg-gradient-info" v-else style="cursor: pointer;" title="Minta QC Inspection untuk barang ini" @click.stop="requestQc(row.id)">Request QC</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.created_by }}</span>
                      </td>
                      <td>
                        <i class="fas fa-edit fa-sm" aria-hidden="true" title="Edit data ini" style="cursor: pointer; margin-right: 20px;" @click="edit(row.id)"></i>
                        <i class="fa fa-clone fa-sm" aria-hidden="true" title="Duplikat data ini" style="cursor: pointer; margin-right: 20px;" @click="duplicate(row.id)"></i>
                        <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus data ini" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-left">TOTAL ROWS : {{table.data.length}} </div>
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD DATA ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title"></span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <h5 class="text-center font-weight-bold mb-3" style="margin-top: 0px;">ITEM RECEIVE</h5>
        <div class="float-end">
         <!--  <a style="margin-top: -40px;" class="btn btn-xs btn-warning d-none d-md-block" :href="apiUrl+'print-pdf/surat-barang-keluar?no_sj='+dataBarangMasuk.no_sj+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a> -->
        </div><hr>
        <div class="row mt-4">
          <div class="col">
            <!-- ==================== HEADER ==================== -->
            <div class="row">
              <div class="col-6">
                <p style="margin-top: 0px;">
                  PO NO.&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;: <input style="border: 1px solid black;" v-model="dataBarangMasuk.po_no" size="30" @keyup="cekPO()"><br>
                  Date &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp; : <input type="date" style="border: 1px solid white;" v-model="dataBarangMasuk.date" size="2">
                </p>
              </div>
              <div class="col-6">
              </div>
            </div><hr>
            <!-- ============== TEBEL Item ITEM ============== -->
            <div class="table-responsive p-0 scroll">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr style="background-color: #F0F8FF;">
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">NO</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">ITEM CODE</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">ITEM NAME</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">SPECIFICATION</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">SIZE</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">UNIT</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">ORDERED</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">SUDAH DITERIMA</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">SISA</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">QTY DITERIMA</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">REQUEST QC</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in tableItemPo.data" :key="i">
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ i + 1 }} </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ row.no_item }} </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ row.part_name }} </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ row.specification }} </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ row.size }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{ row.unit }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{ row.qty }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{ row.qty_received || 0 }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{ (row.qty - (row.qty_received || 0)) }} </span>
                    </td>
                    <td class="align-middle text-center" style="min-width: 110px;">
                      <input type="number" step="0.01" min="0.01" class="form-control form-control-sm" v-model="row.qty_to_receive">
                    </td>
                    <td class="align-middle text-center">
                      <input type="checkbox" class="form-check-input" v-model="row.qc_requested" title="Minta QC Inspection untuk barang ini">
                    </td>
                    <td>
                      <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
                      <span v-else><i class="fa fa-check-circle fa-sm text-success" aria-hidden="true" title="Tambahkan item ini ke Barang Masuk" style="cursor: pointer; margin-right: 20px;" @click="save(row.no_item, row.qty_to_receive, '', row.item_pr_code, row.qc_requested)"></i></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div><hr>
            <div class="text-center mt-5">
              <!-- <div class="">
                <argon-button color="success" variant="gradient" size="xs mb-4" width="1" @click="generateSJNo(), dataBarangMasuk = {}, form.show = false"> <span style="margin-left: 400px; margin-right: 400px;"><i class="fa fa-check" aria-hidden="true"></i> Finished</span></argon-button>
              </div> -->
            </div>

          </div>
        </div>
      </div>
    </vue-final-modal>
  </div>


  <!-- MODAL EDIT / DUPLICATE -->
  <div class="container">
    <vue-final-modal v-model="formEdit.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formEdit.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formEdit.show = false"></i>
        </div>
      </div><hr>
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Item Code <span style="color: red;">*</span></label>
        <!-- <input type="text" class="form-control" placeholder="Item Code" v-model="dataBarangMasuk.material_code" required @change="cekMaterial()">  -->

        <multiselect v-model="dataBarangMasuk.material_code" :options="tableItem.data" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Search Item" label="material_name" track-by="material_name" :preselect-first="true" @keyup="getItem" :custom-label="nameWithLangWo" @select="cekMaterial()" disabled>
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect> 
        <label for="example-text-input" class="form-control-label mt-3">Item Name <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Item Name" v-model="dataBarangMasuk.material_name" required @change="cekMaterial()" disabled="">
        <label for="example-text-input" class="form-control-label mt-3">Specification</label>
        <input type="text" class="form-control" placeholder="Specification" v-model="dataBarangMasuk.specification" disabled="">
        <label for="example-text-input" class="form-control-label mt-3">Unit <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="dataBarangMasuk.unit" disabled="">
          <option v-for="(u, k) in tableUom.data" :key="k" :value="u.code">{{ u.name }}</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Qty <span style="color: red;">*</span></label>
        <input type="number" class="form-control" placeholder="Qty" v-model="dataBarangMasuk.qty">
        <label for="example-text-input" class="form-control-label mt-3">Note </label>
        <input type="text" class="form-control" placeholder="Note" v-model="dataBarangMasuk.note" required>
        <label for="example-text-input" class="form-control-label mt-3">Date <span style="color: red;">* </span></label>
        <input type="date" class="form-control" placeholder="Date" v-model="dataBarangMasuk.date" required>
        <label for="example-text-input" class="form-control-label mt-3">PO No. <span style="color: red;">* </span></label>
        <input type="text" class="form-control" placeholder="PO No." v-model="dataBarangMasuk.po_no" required>
      </div>
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="form.show = true">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="editData()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span>Save</span>
            </span>
          </argon-button>
        </div>
      </div>
    </vue-final-modal>
   </div>

   <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Item Code</label>
        <input type="text" class="form-control" placeholder="Item Code" v-model="search.material_code">
        <label for="example-text-input" class="form-control-label mt-3">Item Name</label>
        <input type="text" class="form-control" placeholder="Item Name" v-model="search.material_name" required>
        <label for="example-text-input" class="form-control-label mt-3">Type</label>
        <select class="form-select" aria-label="Default select example" v-model="search.type">
          <option value="Consumable">Consumable</option>
          <option value="Welding Rod">Welding Rod</option>
          <option value="Sparepart">Sparepart</option>
          <option value="Tools">Tools</option>
          <option value="Other">Other</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Note</label>
        <input type="text" class="form-control" placeholder="Note" v-model="search.note">
        <label for="example-text-input" class="form-control-label mt-3">Date Range</label>
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.date"/>
        <label for="example-text-input" class="form-control-label mt-3">PO No.</label>
        <input type="text" class="form-control" placeholder="PO No." v-model="search.po_no">
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilter.show = true">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="get()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL IMPORT ======= -->
  <div class="container">
    <vue-final-modal v-model="formImport.show" classes="modal-container" content-class="modal-content" :z-index="10000">
    <!-- header -->
    <div class="row">
      <div class="col-11 float-left">
        <span class="modal__title">{{formImport.title}}</span>
      </div>
      <div class="col-1 float-right">
        <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formImport.show = false"></i>
      </div>
    </div><hr>
    <!-- end header -->
    <div class="modal__content container">
      <div>
        <label for="example-text-input" class="form-control-label mt-3">Upload File <span style="color: red;">*</span></label>
        <input type="file" class="form-control" placeholder="Upload File" @change="filesChange" style="margin-bottom: 20px;">
        <small>Download Template<a :href="storageUrl+'/template_import/Template Import Data Karyawan.xlsx'" style="color: blue;"> Import Data Karyawan</a></small>
        <div class="mt-2" v-if="tabelError.data.length !== 0 ">
          <table>
            <thead>
              <slot name="columns">
                <tr style="background-color: #F0F8FF;">
                  <th style="font-size: 13px; text-align: center;">Column</th>
                  <th style="font-size: 13px; text-align: center;">Error</th>
                  <th style="font-size: 13px; text-align: center;">Row</th>
                  <th style="font-size: 13px; text-align: center;">Values</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tabelError.data" :key="i">
                <td style="font-size: 13px; text-align: center;">{{ row.attribute }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.errors }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.row }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.values }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="row float-right mt-5">
      <div class="col-6"> 
      </div>
      <div class="col-2" style="margin-right: 20px;">
        <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formImport.show = false">Close</argon-button>
      </div>
      <div class="col-1">
        <button type="primary" class="btn btn-sm btn-info btn-fill" @click="importData()" :disabled="onLoading">
          <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
          <span v-else>
              <span>Import</span>
          </span>
        </button>
        <!-- <argon-button variant="gradient" color="success" size="sm" width="1" @click="get(), formImport.show = false">Import</argon-button> -->
      </div>
    </div>
    <!-- end footer -->
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css';
var moment = require('moment');
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import barangMasuk from '@/services/barangMasuk.service';
import akun from '@/services/akun.service';
import stockBarang from '@/services/stockBarang.service';
import purchaseOrder from '@/services/procurement/purchaseOrder.service';
import unitOfMeasurement from '@/services/unitOfMeasurement.service';

export default {
  name: "tables",
  components: {
    ArgonButton,
    VueFinalModal,
    flatPickr,
    BasePagination,
    Multiselect,
  },
  data() {
    return {
      moment:moment,
      pagination: {
        page_count: '',
        page: 1,
      },
      table: {
        data: []
      },
      tableUom: {
        data: []
      },
      tableItem: {
        data: []
      },
      tableItemPo: {
        data: []
      },
      form: {
        add: true,
        title: "Add Data",
        show: false
      },
      formEdit: {
        add: true,
        title: "Edit Data",
        show: false
      },
      formImport: {
        add: true,
        title: "Import Data Karyawan",
        show: false
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      dataImport: '',
      onLoading: false ,
      tabelError: {
        data: []
      },
      storageUrl : config.storageUrl,
      dataBarangMasuk: {},
      search: {
        material_code: '',
        material_name: '',
        type: '',
        note: '',
        date: '',
      },
      apiUrl :config.apiUrl,
      role: '',
      backgroundRed: null,
    };
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
    this.getRole();
    this.getUom();
  },
  methods: {
    getUom(){
      let context = this;
      Api(context, unitOfMeasurement.index()).onSuccess(function(response) {
          context.tableUom.data = response.data.data.data;
      }).onError(function(error) {
          if (error.response.status == 404) {
              context.tableUom.data = [];
          }
      })
      .call()
    },
    get(param){
      let context = this;               
      Api(context, barangMasuk.index({material_code: context.search.material_code, material_name: context.search.material_name, type: context.search.type, note: context.search.note, date: context.search.date, po_no: context.search.po_no, page: context.pagination.page})).onSuccess(function(response) {    
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page

          // context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show  = false;
      })
      .call()
    },
    getRole(){
      let context = this;     
      Api(context, akun.indexProfile()).onSuccess(function(response) {
          context.role = response.data.data[0].role;
      }).onError(function(error) {  
      })
      .call() 
    },
    nameWithLangWo ({ material_code, material_name }) {
      return `${material_code} - ${material_name}`
    },
    getItem(param){
      if (param.target.value.length >= 2) {
        let context = this;        
        Api(context, stockBarang.getItem({search: param.target.value})).onSuccess(function(response) {    
            context.tableItem.data = response.data.data;
        }).onError(function(error) {                    
            if (error.response.status == 404) {
                context.tableItem.data = [];
            }
        }).onFinish(function() { 
        })
        .call()
      }
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading = false;
      this.pagination.page  = 1 ;
    },
    create() {
      this.form.add   = true;
      this.form.show  = true;
      this.form.title = "Add Data";
      this.tableItemPo.data   = {};
      this.defaultDate()
    },
    edit(id) {
      let context = this;               
      Api(context, barangMasuk.show(id)).onSuccess(function(response) {
          context.dataBarangMasuk               = response.data.data.data;
          context.dataBarangMasuk.qty_old       = response.data.data.data.qty;
          context.dataBarangMasuk.material_code = response.data.data.dataItem;
          context.formEdit.show                 = true;
          context.formEdit.title                = 'Edit Data';       
      })
      .call()        
    },
    duplicate(id) {
      let context = this;               
      Api(context, barangMasuk.show(id)).onSuccess(function(response) {
          context.dataBarangMasuk.material_code    = response.data.data.material_code;
          context.dataBarangMasuk.material_name    = response.data.data.material_name;
          context.dataBarangMasuk.specification    = response.data.data.specification;
          context.dataBarangMasuk.type             = response.data.data.type;
          context.dataBarangMasuk.unit             = response.data.data.unit;
          context.dataBarangMasuk.min_stock        = response.data.data.min_stock;
          context.dataBarangMasuk.stock_barang     = response.data.data.stock_barang;
          context.dataBarangMasuk.storage_location = response.data.data.storage_location;
          context.dataBarangMasuk.image            = response.data.data.image;

          context.dataBarangMasuk               = response.data.data.data;
          context.dataBarangMasuk.qty_old       = response.data.data.qty;
          context.dataBarangMasuk.material_code = response.data.data.dataItem;
          context.dataBarangMasuk.po_no         = response.data.data.dataItem.po_no;
          context.formEdit.show                 = true;
          context.formEdit.title                = 'Duplicate';       
      })
      .call()        
    },
    cekPO() {
      let context = this;
      Api(context, purchaseOrder.cekPO({po_no: context.dataBarangMasuk.po_no})).onSuccess(function(response) {
          context.tableItemPo.data = response.data.data.dataItemPO;
          // default qty yang diterima = sisa yang belum diterima (bisa diedit manual buat partial receiving)
          context.tableItemPo.data.forEach(function(row) {
            row.qty_to_receive = (row.qty - (row.qty_received || 0));
            // kategori A (MATERIAL) & K (MATERIAL IMPORT) default diminta QC
            row.qc_requested   = ['A', 'K'].includes(row.item_category);
          });
          context.defaultDate()
      })
      .call()
    },
    cekMaterial() {
      let context = this;             
      Api(context, barangMasuk.cekMaterial({material_code: context.dataBarangMasuk.material_code['material_code'], material_name: context.dataBarangMasuk.material_name})).onSuccess(function(response) {
          context.dataBarangMasuk               = response.data.data.data;
          context.dataBarangMasuk.material_code = response.data.data.dataItem;
          context.defaultDate()
      })
      .call()        
    },
    filesChange(e) {
      this.dataBarangMasuk.image = e.target.files[0];
    },
    save(no_item, qty, note, item_pr_code, qc_requested){
      let api      = null;
      let context  = this;
      let formData = new FormData();
      context.onLoading = true;

      if (no_item != undefined && context.dataBarangMasuk.date != undefined) {
        formData.append('material_code', no_item);
        formData.append('qty', qty);
        formData.append('note', note);
        formData.append('date', context.dataBarangMasuk.date);
        formData.append('po_no', context.dataBarangMasuk.po_no);
        formData.append('item_pr_code', item_pr_code);
        formData.append('qc_requested', qc_requested ? 1 : 0);

        // formData.append('material_name', context.dataBarangMasuk.material_name);
        // formData.append('type', context.dataBarangMasuk.type);
        // formData.append('unit', context.dataBarangMasuk.unit);
        // if (context.form.title == 'Add Data') {
        //   formData.append('stock_barang', (context.dataBarangMasuk.qty + ((context.dataBarangMasuk.stock_barang == undefined) ? 0 : context.dataBarangMasuk.stock_barang) ));
        // }else if(context.form.title == 'Edit Data') {
        //   formData.append('stock_barang', ((context.dataBarangMasuk.stock_barang - context.dataBarangMasuk.qty_old) + context.dataBarangMasuk.qty) );
        // }else{
        //   formData.append('stock_barang', (+context.dataBarangMasuk.stock_barang + +context.dataBarangMasuk.qty) );
        // }
        // formData.append('min_stock', context.dataBarangMasuk.min_stock);
        // formData.append('storage_location', context.dataBarangMasuk.storage_location);
        // formData.append('specification', (this.dataBarangMasuk.specification == undefined) ? '' : this.dataBarangMasuk.specification);
        // formData.append('image', (this.dataBarangMasuk.image == undefined) ? '' : this.dataBarangMasuk.image);
      }else{
        context.onLoading = false;
        return alert('The Red Star Field is Mandatory')
      }

      if (context.form.title == 'Add Data') {
          api = Api(context, barangMasuk.create(formData));
      } else if(context.form.title == 'Edit Data') {
          api = Api(context, barangMasuk.update(this.dataBarangMasuk.id, formData));
      }else{
          api = Api(context, barangMasuk.duplicate(formData));
      }
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.get();
        context.cekPO();
        // context.form.show = false;
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')

        // NOTIFIKASI kalau qty yang diterima berbeda dari sisa PO
        if (response.data.data.is_discrepancy) {
          context.notify('Qty diterima ('+qty+') berbeda dari sisa PO ('+response.data.data.qty_po_remaining+')', 'error')
        }
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) {
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')
      }).onFinish(function() {
        context.onLoading = false;
      })
      .call();
    },
    editData(){
      let api      = null;
      let context  = this;
      let formData = new FormData();
      context.onLoading = true;

      console.log(context.dataBarangMasuk.po_no)
      if (context.dataBarangMasuk.date != undefined) {
        formData.append('material_code', context.dataBarangMasuk.material_code['material_code']);
        formData.append('qty', context.dataBarangMasuk.qty);
        formData.append('note', context.dataBarangMasuk.note);
        formData.append('date', context.dataBarangMasuk.date);
        formData.append('po_no', context.dataBarangMasuk.po_no);
      }else{
        context.onLoading = false;
        return alert('The Red Star Field is Mandatory')
      }

      if (context.formEdit.title == 'Edit Data') {
          api = Api(context, barangMasuk.update(this.dataBarangMasuk.id, formData));
      } else if(context.formEdit.title == 'Duplicate') {
          api = Api(context, barangMasuk.duplicate(formData));
      }
     
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.get();
        context.formEdit.show = false;
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
        context.onLoading = false;
      })
      .call();
    },
    remove(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context = this;

        Api(context, barangMasuk.delete(id)).onSuccess(function(response) {
            context.get();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    // modalImport(){
    //   this.formImport.show  = true;
    //   this.formImport.title = "Import Data Karyawan";
    //   this.tabelError.data  = [];
    // },
    // importData(){
    //   let api = null;
    //   let context = this;
    //   let formData = new FormData();
    //   this.onLoading = true;

    //   if (this.dataImport != undefined) {
    //     formData.append('import_data', this.dataImport);
    //   }else{
    //     return alert('File Import Not Found')
    //   }

    //   api = Api(context, barangMasuk.import(formData));
    //   api.onSuccess(function(response) {
    //       context.onLoading = false;
    //       context.get();
    //       context.formImport.show = false;
    //       context.notify('Import Data Success', 'success')
    //   }).onError(function(error) {      
    //       context.tabelError.data = error.response.data.data;              
    //       context.notify('Import Data Failed', 'error')
    //       context.onLoading = false;
    //   }).onFinish(function() {  
    //   })
    //   .call();
    // },
    defaultDate(){
      var date  = new Date();
      var day   = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var today = date.getFullYear() + "-" + (month) + "-" + (day);

      this.dataBarangMasuk.date = today
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    setBg(id) {
      this.backgroundRed = id
    },
    requestQc(id) {
      if (!confirm("Kirim request QC Inspection untuk barang ini?")) {
        return;
      }
      let context = this;
      // eslint-disable-next-line no-unused-vars
      Api(context, barangMasuk.requestQc(id)).onSuccess(function(response) {
          context.get();
          context.notify('Request QC Berhasil Dikirim', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) {
          context.notify('Request QC Gagal', 'error')
      })
      .call()
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
/*MODAL WIDTH KUSUS LEBAR BESAR*/
::v-deep .modal-content-width {
  /*display: flex;*/
  /*flex-direction: column;*/
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1090px;
  margin-top: auto;
  margin-bottom: auto;
}
.scroll { 
  overflow: auto; 
  height: 600px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #F0F8FF;
}
</style>
